<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-05-11 22:33:54
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="visible"
      :title="title"
      :visible.sync="visible"
      width="30%"
      @close="close"
    >
      <el-form :model="cleanDetail" ref="form" size="small" label-width="100px">
        <el-form-item label="社区">
          <el-input :value="cleanDetail.wlCommunityName" readonly></el-input>
        </el-form-item>
        <el-form-item label="点位">
          <el-input :value="cleanDetail.pointPosition" readonly></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-input :value="typeCode[cleanDetail.type]" readonly></el-input>
        </el-form-item>
        <el-form-item label="清运类型">
          <el-input :value="cleanTypeCode[cleanDetail.cleanType]" readonly></el-input>
        </el-form-item>
        <el-form-item label="位置">
          <el-input :value="cleanDetail.position" readonly></el-input>
        </el-form-item>
        <el-form-item label="清运前照片">
          <template v-if="cleanDetail.cleanBeforePhoto">
            <el-image
              v-for="(item, i) in cleanDetail.cleanBeforePhoto"
              style="width: 100px; height: 50px"
              :src="item"
              :preview-src-list="[item]"
              :key="i"
            >
              <div slot="error" class="image-slot" style="width: 100px; height: 50px">
                <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
              </div>
            </el-image>
          </template>
        </el-form-item>
        <el-form-item label="清运中照片">
          <template v-if="cleanDetail.cleanDoingPhoto">
            <el-image
              v-for="(item, i) in cleanDetail.cleanDoingPhoto"
              style="width: 100px; height: 50px"
              :src="item"
              :preview-src-list="[item]"
              :key="i"
            >
              <div slot="error" class="image-slot" style="width: 100px; height: 50px">
                <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
              </div>
            </el-image>
          </template>
        </el-form-item>
        <el-form-item label="清运后照片">
          <template v-if="cleanDetail.cleanAfterPhoto">
            <el-image
              v-for="(item, i) in cleanDetail.cleanAfterPhoto"
              style="width: 100px; height: 50px"
              :src="item"
              :preview-src-list="[item]"
              :key="i"
            >
              <div slot="error" class="image-slot" style="width: 100px; height: 50px">
                <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
              </div>
            </el-image>
          </template>
        </el-form-item>
        <el-form-item label="过磅单照片">
          <template v-if="cleanDetail.weighingListPhoto">
            <el-image
              v-for="(item, i) in cleanDetail.weighingListPhoto"
              style="width: 100px; height: 50px"
              :src="item"
              :preview-src-list="[item]"
              :key="i"
            >
              <div slot="error" class="image-slot" style="width: 100px; height: 50px">
                <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
              </div>
            </el-image>
          </template>
        </el-form-item>
        <el-form-item label="毛重">
          <el-input :value="cleanDetail.grossWeight ? cleanDetail.grossWeight + 'KG' : ''" readonly></el-input>
        </el-form-item>
        <el-form-item label="皮重">
          <el-input :value="cleanDetail.tareWeight ? cleanDetail.tareWeight + 'KG' : ''" readonly></el-input>
        </el-form-item>
        <el-form-item label="净重">
          <el-input :value="cleanDetail.netWeight ? cleanDetail.netWeight + 'KG' : ''" readonly></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :value="cleanDetail.remark" autosize readonly></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['cleanDetail'],
  data () {
    return {
      title: '详情',
      visible: false,
      typeCode: {
        1: '清运记录',
        2: '过磅单',
      },
      cleanTypeCode: {
        1: '村内清运',
        2: '外围偷倒清运',
        3: '台账清运',
        4: '其他清运',
        5: '分拣中心',
        6: '外运马坡',
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    add () {
      this.visible = true
    },
    close () {
      this.visible = false
    },
  },
  created () { },
  mounted () {
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  .menuBar {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    /*height: calc(100% - 100px);*/
    height: 300px;
    overflow-y: auto;
  }
}
</style>
